__turbopack_context__.v({
  "className": "ibm_plex_sans_arabic_560a4c54-module__q2QVEq__className",
});
